// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.billing-section-title {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}
.billing-section-title mat-icon {
  margin-right: 8px;
  color: var(--ion-color-secondary-contrast);
}

.billing-card {
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.billing-card h4 {
  margin: 0 0 15px;
  font-size: 1.2rem;
}

.chart-container {
  width: 220px; /* Aumenté el tamaño para que se vea mejor */
  height: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.progress-label {
  font-size: 1rem;
  font-weight: bold;
  margin-top: 10px;
  color: #333;
}

.billing-content {
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/billing-summary/billing-summary.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAEF;AAAE;EACE,iBAAA;EACA,0CAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA,EAAA,4CAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".billing-section-title {\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n\n  mat-icon {\n    margin-right: 8px;\n    color: var(--ion-color-secondary-contrast);\n  }\n}\n\n.billing-card {\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.billing-card h4 {\n  margin: 0 0 15px;\n  font-size: 1.2rem;\n}\n\n.chart-container {\n  width: 220px; /* Aumenté el tamaño para que se vea mejor */\n  height: 220px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.progress-label {\n  font-size: 1rem;\n  font-weight: bold;\n  margin-top: 10px;\n  color: #333;\n}\n\n.billing-content{\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
